import React from "react";

import Store from "store";
import Api from "api";

import { mapStackTrace } from "sourcemapped-stacktrace";
import { exportAllProfiles } from "logic/import";
import { getProfilePath } from "common";

const mapStackTraceP = (stack) =>
  new Promise((resolve) => {
    mapStackTrace(stack, (result) => resolve(result));
  });

export default class ErrorReporter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error) {
    return { error: { message: error.message, stack: error.stack } };
  }

  componentDidCatch(error, info) {
    Promise.all([
      mapStackTraceP(error.stack),
      mapStackTraceP(info.componentStack),
    ]).then(([stack, components]) =>
      this.setState((state) => ({
        error: {
          ...state.error,
          stack: stack.join("\n"),
          components: components.join("\n"),
        },
      }))
    );
  }

  onSave = () => {
    const state = Store.instance.getState();
    const historyState = this.props.history.getState();
    const api = new Api();
    this.setState({ saved: { saving: true } });
    api
      .save(exportAllProfiles(state, historyState, "Error report"), {
        error: true,
      })
      .then(
        (id) => this.setState({ saved: { id } }),
        (error) => this.setState({ saved: { error: error.message } })
      );
  };

  render() {
    if (this.state.error) {
      const {
        saved,
        error: { message, stack, components },
      } = this.state;

      return (
        <div className="d3p-ErrorReport">
          <div>
            <h3>Oops! Something broke.</h3>
            <p>
              Please submit a report over at{" "}
              <a
                href="https://discord.gg/WBBwg5X"
                target="_blank"
                rel="noopener noreferrer"
              >
                Maxroll discord
              </a>{" "}
              describing what you were doing, along with the information below.
            </p>
            <p>
              If you believe the profile is relevant, please include a link to
              it as well.
            </p>
            <p>
              {!saved && (
                <span className="d3p-save" onClick={this.onSave}>
                  Save profile
                </span>
              )}
              {!!(saved && saved.saving) && <span>Saving...</span>}
              {!!(saved && saved.id) && (
                <a
                  href={getProfilePath(saved.id)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {new URL(getProfilePath(saved.id), window.location.href).href}
                </a>
              )}
              {!!(saved && saved.error) && (
                <span className="d3p-error">{saved.error}</span>
              )}
            </p>
            <div className="d3p-report">
              The following error has occurred: {message || "Unknown error"}
              {"\n"}
              {!!stack && stack + "\n"}
              {!!components && "Components:\n" + components + "\n"}
              User agent: {navigator.userAgent}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
